// API endpoints
export const PUBLIC_API_ENDPOINT = process.env.REACT_APP_PUBLIC_API_ENDPOINT

export const PUBLIC_PAGE_API_ENDPOINT =
	process.env.REACT_APP_PUBLIC_PAGE_API_ENDPOINT

export const PUBLIC_MYPAGES_API_ENDPOINT =
	process.env.REACT_APP_PUBLIC_MYPAGES_API_ENDPOINT

export const DEVELOPMENT_MODE = process.env.NODE_ENV === "development"

export const PIWIK_PRO_CONTAINER_URL =
	process.env.REACT_APP_PIWIK_PRO_CONTAINER_URL

// Z indexes
export const Z_INDEX = {
	Drawer: 20,
	MyPagesMenu: 20,
	Header: 30,
	Modal: 70,
}

export const queryStaleTime = 10 * 200 // 10 ms * 200 = 2 seconds
export const queryRefetchInterval = 10 * 6000 // 10 ms * 6000 = 1 minute
